/* eslint-disable */
import React, { Component } from 'react'
import { View, Text, TouchableOpacity, Dimensions, TextInput, Image, ScrollView, Animated, Keyboard, Linking, FlatList, Alert, ActivityIndicator, Platform } from 'react-native'
//import { KeyboardAccessoryNavigation } from 'react-native-keyboard-accessory'
import { Fonts } from '../Themes'
import { SvgCloseBlack } from './SvgComponent'
import { RecyclerListView, DataProvider, LayoutProvider } from 'recyclerlistview'
import LinearGradient from 'react-native-linear-gradient'
import { getAvatar, generateKey, isIPhoneX, deepClone } from '../Lib/utils'
//import RNFetchBlob from 'react-native-fetch-blob'
import DocumentPicker from 'react-native-document-picker'
//import RNFS from 'react-native-fs'

import Images from "../Themes/Images"
import SearchBarComponent from './SearchBarComponent'
import AvatarComponent from './AvatarComponent'
import UserFollowComponent from './UserFollowComponent'
import HashtagComponent from './HashtagComponent'
//import Autolink from 'react-native-autolink'
//import SafariView from '../Lib/SafariView/'

import API from '../Services/Api'
import FixtureAPI from '../Services/FixtureApi'
import DebugConfig from '../Config/DebugConfig'
import I18n from "i18n-js"

import moment from 'moment'
import { indexOf } from 'lodash'
import { TabView, TabBar } from 'react-native-tab-view';

// import SoundRecorder from 'react-native-sound-recorder'
// import SoundPlayer from 'react-native-sound-player'

import NotificationManager from '../Lib/NotificationManager'

let { width : componentWidth, height : h } = Dimensions.get('window')

const font = Fonts.style.font.regular
const regularFond = Fonts.style.font.regular
const boldFont = Fonts.style.font.bold

const ENCODED_REPLY_PATTERN             = '^reply to .link profile [A-Za-z0-9]+ none @.+. from [0-9]+.[0-9]+:'

const ENCODED_REPLY_PATTERN_BEFORE_TIME = '^reply to .link profile [A-Za-z0-9]+ none @.+. from '

const AUDIO_PATTERN = '.*audioComment https:'

const AUDIO_PATTERN_TO_END = '.*audioComment https:.*$'

const AUDIO_GET_URL_PATTERN = '.*audioComment '

const AUDIO_GET_DURATION_PATTERN = '.*audioComment https:.* duration '


//const log = (str) => NotificationManager.postNotificationWithString("AppDelegate_printf", str)
const log = (str) => null

const convertTime = (unixTime) => {

  var date = new Date(unixTime * 1000);
  var dayWrapper = moment(date);
  const now = moment()

  const diff = dayWrapper.diff(now, null, true);
  const diffDuration = moment.duration(diff);
  let days = Math.abs(diffDuration.days())
  let hours = Math.abs(diffDuration.hours())
  let minutes = Math.abs(diffDuration.minutes())
  let seconds = Math.abs(diffDuration.seconds())
  if (days > 0) {
    return String(days) + "d"
  } else if (hours > 0) {
    return String(hours) + "h"
  } else if (minutes > 0) {
    return String(minutes) + "m"
  } else {
    return String(seconds) + "s"
  }
}

const Tab = (props) => {
  return props.active
  ? <LinearGradient colors={['#b77fd5', '#b1e8eb']} start={{ x : 0, y : 0 }} end={{ x : 0, y : 1 }} style={{ flex : 1/3, borderWidth : 1, borderColor : '#000000FF', height : props.height }}>
      <TouchableOpacity onPress={props.onPress} activeOpacity={0.5}>
        <Text style={{ fontFamily : font, fontSize : 14, textAlign : 'center', lineHeight : props.height }}>
          {props.text}
        </Text>
      </TouchableOpacity>
    </LinearGradient>
  : <TouchableOpacity style={{ flex : 1/3, borderWidth : 1, borderColor : '#00000070', height : props.height }}
                      onPress={props.onPress} activeOpacity={0.5}>
      <Text style={{ fontFamily : font, fontSize : 14, textAlign : 'center', lineHeight : props.height }}>
        {props.text}
      </Text>
    </TouchableOpacity>
}

class EfficientFlatList extends FlatList {
  constructor(props) {
    super(props)
    this.state = {nItems: 0}
  }

  shouldComponentUpdate(nextProps, nextState) {
    //console.log("efficient next props = " + JSON.stringify(Object.keys(nextProps)))
    //console.log("efficient next state = " +  JSON.stringify(Object.keys(nextState)))
    let priorNItems = this.state.nItems
    this.state.nItems = nextProps.nItems
    // simple numeric check this doesnt account for the case of a user deleting 1 comment and some one
    // else posting one (e.g. same final total however it happens) 
    let shouldRender = priorNItems !== nextProps.nItems
    //console.log("efficient flat list should render = " + shouldRender)
    return shouldRender
  }

}
// send in prop isPopup to show only comment entry stuff not full screen list

export default class PostViewComponent extends Component {
  constructor(props) {
    //console.info("!!! post view component constructor")

    super(props)

    this.adjustWidthForWeb = () => {
      // test for web 
      if (typeof window.mainViewWidthFraction != 'undefined' && window.mainViewWidthFraction < 1) {
        if (!this.props.standaloneScreen) // in normal stack
          componentWidth = Dimensions.get('window').width * window.mainViewWidthFraction       
        else // right side standalone screen
          componentWidth = Dimensions.get('window').width (1-window.mainViewWidthFraction)
      }
    }

    //this.adjustWidthForWeb()

    const tabConstant = ['Loves', 'Comments', 'Hashtags']
    const paramPost = this.props.Post
      this.api = DebugConfig.useFixtures ? FixtureAPI : API.create()
      this.api.setAuthorization(this.props.auth.token)
    this.PostId = paramPost.PostId
    this.hashtags = paramPost.Tags ? [...paramPost.Tags] : []
    this.basicProvider = new DataProvider( (r1,r2) => r1 !== r2 )
    this.lovesLayout = new LayoutProvider( index => 0, (type,dim) => { dim.width = componentWidth; dim.height = 60 })
    this.hashesLayout = new LayoutProvider( index => 0, (type,dim) => { dim.width = componentWidth; dim.height = 50 })
    this.editablePost = paramPost.UserId === this.props.auth.user.UserId
    this.hashTagScrollView = null
    this.commentScrollView = null
    let adjustedOffset = isIPhoneX() ? 31 : 20 // avoid overlapping status bar & notch, corrected
    this.sizes = {
      belowKeyboardHeight: isIPhoneX() ? 0 : 0
    , offset : adjustedOffset
    , title : 44
    , tab : 55 // 50
    , captionMinHeight : 100
    , captionMaxHeight : 100
    }
    this.captionSize = new Animated.Value(Infinity)

    this.select = [0,0]
    this.activeSearch = [ ]
    this.rowOffset = []

    this.keyboardWillShowListener = Keyboard.addListener('keyboardWillShow', this.keyboardWillShow.bind(this))
    this.keyboardWillHideListener = Keyboard.addListener('keyboardWillHide', this.keyboardWillHide.bind(this))
    console.log(paramPost)

    let tagRows = paramPost.Tags ? [...(paramPost.Tags.filter(e => e !== 'NULL')), null, null] : []

    this.state = {
      Post: deepClone(paramPost)
    ,  width : componentWidth - this.sizes.offset*2
    , height : h - this.sizes.offset*2
    , tab : indexOf(tabConstant, this.props.defaultTab) || 0
    , scrollToCommentTimeStamp : this.props.commentTimeStamp // can be 0 in which case ignored
    , loves : this.basicProvider.cloneWithRows([ ])
    , tags : this.basicProvider.cloneWithRows(tagRows)
    , comments : [ ]
    , hashTagInput : ''
    , commentInput : ''
    , canExpand : false
    , showingMore : 'loading'
    , following : [ ]
    , modal : false
    , routes: [
      { key: 'loves', title: I18n.t('postDetail.loves')      /*'Loves'*/ },
      { key: 'comments', title: I18n.t('postDetail.comment') /*'Comments'*/ },
      { key: 'hashtags', title: I18n.t('postDetail.hashtag') /*'Hashtags'*/ }
    ]
    , commentBeingSent : false
    , shouldClearTyping : false // normally false, set to try to force clear the "search" bar which is used for comment data entry
    , forceRedrawComments : false // normally false, when data comes back from server API should set to true and it will trigger 1 redraw
    , commentCountDelta : 0
    , replyingNow : false
    , replyPrefix : ''
    , replyToComment: null
    , justGotPostIndex: -1 // not used yet
    , isRecording: false
    , hasRecorded : false
    , audioDurationSeconds: 0
    , newAudioFilePath: ''
    , audioIsPosting: false
    , PDFIsPosting: false
    , recordOn : false // from external caller
    , playOn: false
    , recordingTimeStart: 0 // absolute time millisec
    , recordingTimeMillisec: 0 // absolute time, so subtract start
    , voiceLevel: 1.0
    }
    this.keyboardHeight = new Animated.Value(0)
    this.whiteLine = new Animated.Value(0)
    
    const loveChanges = this.props.loveChanges
    const changeEntry = loveChanges.length > 0 ? this.props.loveChanges[0] : null
    const likedThisPost = changeEntry && changeEntry.PostId == this.PostId && changeEntry.Relationship == 'Love' && changeEntry.State == 'success' && changeEntry.Error == null

    this.api.getPostAllLikes(this.PostId)
    .then(resp => {
      if( resp.ok ) {
        let Username = this.props.auth.user.Username
        let UserId = this.props.auth.user.UserId
        // add current user in if they just liked this post, might be missing from API response
        const loveResponse = resp.data.data
        let foundCurrUser = false
        for (i = 0; i < loveResponse.length; i++)
          if (loveResponse[i].UserId == UserId)
            foundCurrUser = true
        const myEntry = likedThisPost && !foundCurrUser ? {
          UserId: UserId,
          Username: Username,
          Following: false,
        } : null
        // console.tron.display({ name: `PostView`, preview: `getPostAllLikes`, value: { loveResponse: loveResponse, likedThisPost: likedThisPost, foundCurrUser: foundCurrUser, myEntry: myEntry, loveChanges: loveChanges } })
        let loves = myEntry ? [myEntry, ...resp.data.data] : [...resp.data.data]
        let Loves = loves.sort((a,b) => {
            if( a.Username === Username ) return -1
            if( b.Username === Username ) return 1
            return a.Username.toLowerCase( ) < b.Username.toLowerCase( )? -1 : 1
          })
        this.setState({ loves : this.basicProvider.cloneWithRows(Loves) })
      }
    })
    .catch(console.log)
    this.api.getPostComments(this.PostId)
    .then(resp => { if( resp.ok ) 
      this.setState({ comments : resp.data.data }) 
      // got comments data first time in
      // now we can scroll to where we want to be if user wants to be at any particular comment based upon time stamp

      // need to wait till sort or just do it here?

      let comments = this.sortCommentsByReply(resp.data.data)
      log("should now scroll to " + this.state.scrollToCommentTimeStamp + " len comments = " + comments.length)
      log(JSON.stringify(comments))
      let idx = comments.findIndex((x) => {
        return x.TimeStamp == this.state.scrollToCommentTimeStamp
      })
    
      console.log('found idx for Timestamp, idx = ' + idx + " this.commentScrollView = " + this.commentScrollView)

      let newIndex = idx
      // may only need the 500 ms timeout who knows lot of possiblities w/ flat list
      setTimeout(() => {
        while (newIndex <= idx) {
          if (newIndex >= 0 && this.commentScrollView) {
            this.commentScrollView.scrollToIndex({
              animated: true,
              index: idx// test
            })
          }
          newIndex += 1
        }
        this.setState({justGotPostIndex: idx}) // not used yet, may be useful 
      }, 500)
    })
    .catch((x) => {
      console.log('caught error trying to get comments x = ' + JSON.stringify(x))
    })
    this.api.getFollowing(this.props.auth.user.UserId, {start: 0})
    .then(resp => { if( resp.ok ) this.setState({ following : resp.data.data }) })
    .catch(console.log)
  }
  
  componentDidMount( ) {
    if (Platform.OS != 'web')
    this.onFinishedLoadingSubscription = SoundPlayer.addEventListener('FinishedLoading', ({ success }) => {
      console.log('audio finished loading', success, "this keys = " + Object.keys(this))
      this.setState({audioFinishedLoading: true})
      SoundPlayer.getInfo().then((x) => {
        this.setState({audioDurationSeconds: x.duration})
      })
    })
    if (Platform.OS != 'web')
    this.onFinishedPlayingSubscription = SoundPlayer.addEventListener('FinishedPlaying', ({ success }) => {
      console.log("audio finished playing")
      this.stopPlayingAudio() // its already stopped but this will reset the states
    })
  }

  componentDidUpdate(prevProps, prevState) {

    //console.info("post view COMPONENT did update: this.props.Post = " + JSON.stringify(this.props.Post))
    //console.log("post view component did update recordOn = " + this.props.recordOn + " this.props.playOn " + this.props.playOn)

    // recommended to just set a prop and call the function internally 
    // ref https://stackoverflow.com/questions/43953791/calling-functions-from-other-components-in-react-native

    if (this.props.recordOn !== prevProps.recordOn) {
      if (this.props.recordOn) {
        console.log("should start recording")
        this.recordAudio.call(this)
      } else {
        console.log("should stop recording")
        this.recordAudio.call(this)
      }
    }

    if (this.props.playOn !== prevProps.playOn) {
      if (this.props.playOn) {
        console.log("should start audio playing")
        this.playAudio.call(this)
      } else {
        console.log("should stop audio playing")
        this.playAudio.call(this)
      }
    }

    if (this.props.addVoiceComment !== prevProps.addVoiceComment) {
      if (this.props.addVoiceComment) 
        this.postAudioAsComment()
    }

    // this should happen for every state change
    if (this.props.audioStateChanged) {
      this.props.audioStateChanged(this.state) // just pass back the whole state for now so we can get what we want
    }
  }

  componentWillUnmount( ) {
    if (this.onFinishedLoadingSubscription) this.onFinishedLoadingSubscription.remove()
    this.keyboardWillShowListener.remove( )
    this.keyboardWillHideListener.remove( )
  }
  
  refreshComments( ) {
    //console.log("post view COMPONENT refresh comments")
    if (this.refreshingCommentsNow) return // dont do if doing it so calls dont stack up in case of low network
    if (this.state.commentBeingSent) return // dont refresh when comment is being sent because we have a temp comment displayed
                                            // and it will go bye-bye after a refresh
    this.refreshingCommentsNow = true                                       
    this.api.getPostComments(this.PostId)
      .then(resp => { 
        this.refreshingCommentsNow = false
        if( resp.ok ) this.setState({ comments : resp.data.data }) 
      })
      .catch((x) => {
        this.refreshingCommentsNow = false
        console.log("CATCH refreshCommments " + JSON.stringify(x))
      })
  }

  keyboardWillShow = e => {
    console.log("keybd will show pvc")

    console.tron.display({ name: `PostView`, preview: `keyboardWillShow`, value: { endCoordinates: e.endCoordinates, screenWidth: componentWidth, screenHeight: h } })
    // Animated.timing( this.keyboardHeight, { toValue : e.endCoordinates.height, duration : 333 }).start( )

    // adjust if the entry field is part of a scroll up/down like on main wall
    // bottomOfDataEntry is measured from top of screen = 0

    setTimeout(() => {

      let to = e.endCoordinates.height + this.sizes.belowKeyboardHeight // orig way

      console.log("orig to value = " + to)

      let toFromTop = Dimensions.get('window').height - to

      console.log("to from top value = " + toFromTop)

      if (this.bottomOfDataEntry < toFromTop) { // already high enough, good, dont move
        console.log("field already high enough dont move")
        to = 0 
      }
      else {
      
        let delta = this.bottomOfDataEntry - toFromTop
        console.log("delta = " + delta)

        // orig to - how far the bottom of the data entry field is below the top of the keyboard 
        to =  delta // e.endCoordinates.height + this.sizes.belowKeyboardHeight  - delta
      }

      // but see if we maybe dont have to move so much if the actual position of the typing field is high enough

      Animated.timing( this.keyboardHeight, { toValue : to, duration : 333 }).start( )
      Animated.timing( this.whiteLine, { toValue : 25, duration : 333 }).start( )

    }, this.props.isPopup ? 100 : 0) // wait for measure info to come thru in next cycle if we are in a popup
  }
  
  keyboardWillHide = e => {
    Animated.timing( this.keyboardHeight, { toValue : 0, duration : 333 }).start( )
    Animated.timing( this.whiteLine, { toValue : 0, duration : 333 }).start( )
  }

  collectTags = ( ) => {
    let text = this.state.commentInput
    var tags = [ ]
    for( var i = 0 ; i < text.length ; ++ i ) {
      let c = text[i]
      if( c === '@' ) {
        let begin = i
        for( var j = begin; j < text.length ; ++ j ) {
          let end = text[j]
          if( end === ' ' ) {
            tags.push({ begin : begin, end : j-1 })
            break
          }
        }
        if( j === text.length ) tags.push({ begin : begin, end : text.length })
      }
    }
    return tags
  }
  
  processTags = ( ) => {
    let [ start, end ] = this.select
      , tags = this.collectTags ( )
    var activeTag = false
    for( var i = 0 ; i < tags.length ; ++ i ) {
      let tag = tags[i]
      if( start > tag.begin && end <= (tag.end+1) )
        activeTag = tag
    }
    let priorActiveTag = this.activeTag
    this.activeTag = activeTag
    if (this.activeTag != priorActiveTag) this.setState({ render : true })
    else console.log('skipping re-render since active tag is the same')
  }
  
  onSelect = ({ nativeEvent : { text, selection : { start, end }}}) => {
    // console.log(`selection update: ${start} -> ${end}`)
    this.select = [ start, end ]
    if( end <= this.state.commentInput.length )
      this.processTags ( )
  }
  
  commentInputChange = text => {
    // re-rendering whole component is expensive w/ large comment list
    // maybe can stop re-rendering of the big list of comments when not needed
    console.log("commentInputChange text = " + text)
    this.setState
    ({ commentInput : text } 
    , ( ) => {
      this.processTags ( )

      if( this.activeTag ) {
        let search = this.state.commentInput.slice( this.activeTag.begin+1, this.activeTag.end+1 )
        if( search.length > 2 ) {
          this.searchQuery = search
          this.api.searchUser({ limit : 100, user : search }) // pull more 
          .then(result => {
            let names = result.data.data
            if( this.activeTag ) {
              let newSearch = this.state.commentInput.slice( this.activeTag.begin+1, this.activeTag.end+1 )
              if( newSearch === this.searchQuery )
                this.activeSearch = names
              this.setState({ render : true })
            }
          }).catch(console.log)
        }
      }
    })
  }
  
  insert = ( User ) => {
    let str = this.state.commentInput
      , before = str.slice(0, this.activeTag.begin)
      , after = str.slice(this.activeTag.end+1)
      , next = `${before}@${User.Username}${after}`
    if( after.length < 1 ) next += ' '
    this.select = [0,0]
    this.activeTag = false
    console.log('insert ' + next)
    this.setState({ commentInput : next })
  }
  
  userRow = ( User ) => {
    return (<TouchableOpacity style={{ flexDirection : 'row', backgroundColor : 'white', height : 50, width : '100%' }} activeOpactiy={0.5} onPress={this.insert.bind(this,User)}>
      <Image source={{ uri: getAvatar(User.UserId) }} resizeMode='contain' style={{ width : 40, height : 40, borderRadius : 20, margin : 5 }} />
      { (User.FirstName.length > 1 || User.LastName.length > 1)
          ? <View style={{ flex : 1, flexDirection : 'column' }}>
              <Text style={{ fontSize : 15, lineHeight : 25, marginLeft : 15, color : 'black' }}>{User.Username}</Text>
              <Text style={{ fontSize : 12, lineHeight : 25, marginLeft : 15, color : 'black' }}>{User.FirstName} {User.LastName}</Text>
            </View>
          : <Text style={{ fontSize : 18, lineHeight : 50, marginLeft : 15, color : 'black' }}>{User.Username}</Text>
      }
    </TouchableOpacity>)
  }
  
  tagResults = ( ) => {
    if( ! this.activeTag ) return (<Text></Text>)
    let search = this.state.commentInput.slice( this.activeTag.begin+1, this.activeTag.end+1 )
    const beginsWith = (a,b) => a.length > 2 && a.toLowerCase( ).indexOf( b.toLowerCase( ) ) === 0
    const inUsernameFirstLast = User => beginsWith(User.Username,search) || beginsWith(User.FirstName,search) || beginsWith(User.LastName,search)
    if( search.length < 3 || ! this.activeSearch.length ) {
      return this.state.following
          .filter( inUsernameFirstLast )
          .sort( (a,b) => a.Username < b.Username? -1: 1 )
          .slice(0,5)
          .map(this.userRow)
    } else if( this.activeSearch.length ) {
      return this.activeSearch.slice(0,5).map(this.userRow)
    }
  }
  
  _onRefresh = () => {
    // do we you leave the screen, not for every change
    // this.props.onRefresh()
    if (this.props.isPopup) // if we are in a popup do this after each change so wall gets the update
      this.props.onRefresh()
  }

  hashTagInputChange = text => this.setState({ hashTagInput : text })

  deleteHashtag = tag => {
    let Tags = this.hashtags.filter(e => e !== tag)
    this.api.editHashtags(this.PostId, Tags)
    this.setState({ 
      Post: Object.assign({}, this.state.Post, {Tags}),
      tags: this.basicProvider.cloneWithRows(Tags.filter(e => e !== 'NULL')) 
    })
    this.hashtags = Tags

    this._onRefresh()
  }
  
  addHashtag = ( ) => {
    let input = this.state.hashTagInput.replace(/[^a-zA-Z0-9]/g, '')
      , Post = this.state.Post
      // , Tags = [...this.hashtags, input]
      , Tags = [input, ...this.hashtags]
    if( input.length > 0 ) {
      this.api.editHashtags(Post.PostId, Tags)
      this.setState({ 
        Post: Object.assign({}, this.state.Post, {Tags}),
        hashTagInput : '',
        tags : this.basicProvider.cloneWithRows(Tags.filter(e => e !== 'NULL'))
      })
      this.hashtags = Tags
      this.hashRef.textInput.setNativeProps({ text: '' })
      this._onRefresh()
      this.hashTagScrollView.scrollToIndex(0, true)
    } else {
      this.setState({ hashTagInput : '' })
    }
  }

  addComment = ( ) => {

    // Note: this function temporarily adds the user's new comment to the comment list before 
    // it gets sent/retvd from the server API for faster user feedback.  
    // if server API fails, there is no fallback to correct this
    // and re-send, but the next time user comes into comment list, that failed comment will be gone
    // see:  Darren

    if( this.state.commentInput.length < 1 ) return
    let carray = this.state.comments
    // note the PostId, we won't put an X if it is a temp comment because delete before create is somewhat problematic for now (can solve later)
    let tempComment = {"PostId": "anyPost", "UserId": this.props.auth.user.UserId, "TimeStamp": Date.now()/1000.0, "Body": this.state.commentInput, "Username": this.props.auth.user.Username}
    //console.log("carray before shift = " + JSON.stringify(carray)) // none probably when no comments
    if (!carray || (carray.length === 1 && !carray[0])) carray = []
    if (carray.length === 0)
      carray = [tempComment]
    else
      carray.unshift(tempComment)
    //console.log("ready to set comments to " + JSON.stringify(carray))
    let commentToSend = this.state.commentInput
    // clearing comment input not working 
    // so add a force clear to that component 
    this.setState({comments: carray, commentInput : '', shouldClearTyping: true}) // clear the data entry field for user feedback (comment goes into comment list above) 

    // model: {"PostId":"x68alujhUn3yA7","UserId":"P95758977b04c9140001ac1f18a31409",
    //         "TimeStamp":1567093301.158398,"Body":"the comment typed","Username":"briank15"}
  
    let tA = (new Date()).getTime()
    this.state.commentCountDelta += 1 // dont render yet, just keep track (even if it fails, bump count, it will correct itself later)
    this.setState({commentBeingSent: true}) // do UI stuff to hide delay

    // if this is a reply, prefix the user's text w/ a special string computed by computeReplyString( )
    commentToSend = this.state.replyingNow ? (this.state.replyPrefix + commentToSend) : commentToSend

    this.api.postComment(this.PostId, commentToSend)
    .then(( ) => {
      this.setState({replyingNow : false, replyPrefix: '', replyToComment : null}) // in case these were set, clear them
      let tB = (new Date()).getTime()

      if (this.state.audioIsPosting) // it has been posted!
        if (Platform.OS != 'web')
        SoundPlayer.loadUrl("file://nothing") // this will reset audo len to 0 to avoid double post issue

      this.setState({audioIsPosting: false})
      this.setState({PDFIsPosting: false})

      // *** for new use from wall, refresh full post after a comment goes up, wall should "hear" this thru redux

      let PostId = this.PostId

      const options = {
          PostId: PostId,
          PostIds: [PostId],
          GetLikes: false // who cares, this is for comments
      }
      console.log("INNER comment refresh re-get data for PostId = " + PostId)

      // could moderate this later to do only when necessary
      // no this gets called too much, have to do inside 
      //if (this.props.readPost)
      //  this.props.readPost({PostId: this.PostId})

      this._onRefresh()

      console.log("INNER comment refresh PAST readPost")

      // ****    

      this.api.getPostComments(this.PostId)
      .then(resp => { 
        console.log('resp getPostComments = ' + JSON.stringify(resp, null, 2))
        let tC = (new Date()).getTime()
        console.log("time to send comment = " + (tB-tA) + " time to get comments back = " + (tC-tB))
        this.setState({commentBeingSent: false /*, shouldClearTyping : false*/}) // put UI back to normal (need fallback for this also in case of fail)
        if( resp.ok )  {
          this.captionRef.textInput.setNativeProps({ text: '' })
          this.setState({
            Post: Object.assign({}, this.state.Post, {NumComments: resp.data.data.length}),
            comments : resp.data.data, 
            forceRedrawComments: true
          }) 
          if (this.commentScrollView) {
            // this.commentScrollView.scrollTo({x: 0, y: 0, animated: true})
            this.commentScrollView.scrollTo({x: 0, y: this.rowOffset[1], animated: true})
          } // the catch function is being triggered because of an error thrown in above scroll 
          // this keeps comment input setting back to '' from being called, and leaves data in the text input field
          else {
            console.log("caution, cannot scroll properly to comment")
          }
          setTimeout(function() { // later
            if (this.state) this.state.shouldClearTyping = false
            else console.log("*** caution, cannot reset should clear typing to false")
          }.bind(this), 1000)
        }
      })
      .catch(function(e) {
         if (this.state) {
            this.state.shouldClearTyping = false // no need to render so don't do setState
            console.log("+++ did set should clear typing to false")
         }
         else console.log("cannot set should clear typing to false loc 1 error = " + JSON.stringify(e))
      }.bind(this))
    }).catch(function(e) {
      if (this.state) this.state.shouldClearTyping = false // same as above
      else console.log("cannot set should clear typing to false loc 2")
    })
    // above postComment is async so something else is setting this back to non clear, so clear it in above promise .then
    this.setState({ commentInput : ''}) // back to normal, prep for next comment input
    this._onRefresh()
  }
  
  deleteVerify = TimeStamp => {

    if (Platform.OS == 'web') {
      if (confirm("Delete this comment?")) {
        this.deleteComment(TimeStamp)
      } else {

      }
    }
    else
    Alert.alert(
      "Delete this comment?",
      '',
      [
        {
          text: "Delete",
          onPress: () => this.deleteComment(TimeStamp),
          style: "destructive",
        },
        {
          text: "Cancel",
          onPress: () => {},
          style: "cancel",
        },
      ],
      {
        cancelable: true,
        onDismiss: () =>
          {}
      }
    )
  }
  deleteComment = TimeStamp => {
    console.log('ready to delete comment, call API')
    this.setState({commentCountDelta : this.state.commentCountDelta - 1}) // do now and refresh display
    let tA = (new Date()).getTime()
    this.api.deleteComment(this.PostId, TimeStamp)
    .then(( ) => {
      let tB = (new Date()).getTime()
      console.log("comment has been deleted, ready to refresh comments, time to delete was = " + (tB-tA))
      this.api.getPostComments(this.PostId)
      .then(resp => { //console.log("delete comment resp.data.data = " + resp.data.data)
        let tC = (new Date()).getTime()
        console.log("comment has been deleted, list pull time = " + (tC-tB))
        if( resp.ok ) 
          this.setState({
            Post: Object.assign({}, this.state.Post, {NumComments: resp.data.data.length}),
            comments : resp.data.data,
            forceRedrawComments: true,
            shouldClearTyping: true
          }) 
          setTimeout(function() { // later this needs to be put back to false or user cannot type, because field keeps getting cleared
            if (this.state) this.state.shouldClearTyping = false
            else console.log("*** caution, cannot reset should clear typing to false")
          }.bind(this), 1000)
      })
      .catch(console.log)
    }).catch(function(e) {
      console.log("error cannot delete comment " + JSON.stringify(e))
    })

    this._onRefresh()
  }

  MoreLess = ( ) => {
    if( this.state.showingMore === 'loading' ) {
      this.captionSize = new Animated.Value(this.sizes.captionMinHeight)
      this.setState({ showingMore : false })
    } else {
      this.setState
      ({ showingMore : !this.state.showingMore }
      , ( ) => Animated.timing
        ( this.captionSize
      , { toValue : (this.state.showingMore
                    ? this.sizes.captionMaxHeight
                    : this.sizes.captionMinHeight)
        , duration: 333
        }).start( )
      )
    }
  }

  LovesView = ( ) => {
    let remainingHeight = h - this.sizes.offset*2 - this.sizes.title - this.sizes.tab
    return (
      <View style={{ width : componentWidth, height : remainingHeight }}>
        <RecyclerListView style={{ width : '100%', height : remainingHeight }} disableRecycling={true}
        layoutProvider={this.lovesLayout} dataProvider={this.state.loves} renderAheadOffset={50}
        rowRenderer={ (type, data) => <UserFollowComponent data={data} fontSize={14} api={this.api} auth={this.props.auth} navigation={this.props.navigation}/> }/>
      </View>
    )
  }
  
  HashtagView = ( ) => {
    let remainingHeight = h - this.sizes.offset - this.sizes.title - this.sizes.tab
      , remainingWidth = componentWidth - 10*2
      , editablePost = this.editablePost
      , editContainerHeight = editablePost ? 66 : 0 // remainingHeight * 0.075
      // , editHeight = editablePost ? 35 : 0
      , listHeight = remainingHeight - editContainerHeight - 20 // 0.9 * remainingHeight
    // <RecyclerListView style={{ backgroundColor: 'brown', width : '100%', maxHeight : recyclerHeight - 50}} disableRecycling={true}
    console.tron.display({ name: `PostView`, preview: `HashtagView`, value: { height: h, sizes: this.sizes, listHeight: listHeight } })
/*    
    return (
      <View style={{ backgroundColor: 'orange', maxWidth : w, height : remainingHeight, maxHeight : remainingHeight }}>
        <View style={{ backgroundColor: 'blue', maxWidth : w, height : remainingHeight - editContainerHeight, flexDirection : 'column', alignItems : 'center', justifyContent : 'space-between', marginLeft: 10, marginRight: 10 }}>
          <RecyclerListView style={{ backgroundColor: 'brown', width : '100%', maxHeight : recyclerHeight - 10 }} disableRecycling={true}
          layoutProvider={this.hashesLayout} dataProvider={this.state.tags} renderAheadOffset={50}
          rowRenderer={ (type, data) => <HashtagComponent data={data} post={this.props.Post} api={this.api} editable={editablePost}
                                        auth={this.props.auth} navigation={this.props.navigation} delete={this.deleteHashtag} /> }/>
        </View>
        { editablePost &&
          <Animated.View style={{ backgroundColor: 'green', maxWidth : w, height : editContainerHeight + 11, position : 'absolute', bottom : this.keyboardHeight, marginTop: 5, marginBottom: 15, zIndex : 5000 }}>
            <View style={{ backgroundColor: 'lime', maxWidth : w, flexDirection : 'row'
                          , justifyContent : 'center', alignItems : 'center', borderWidth : 1, borderColor : 'black', borderRadius : 5
                          , minWidth : (w - 10*2), margin : 10, padding : 10 }}>
              <TextInput style={{ backgroundColor: 'yellow', flex : 8.5/10, color : 'black', height : editHeight, fontFamily : font, fontSize : 14, fontStyle : this.state.hashTagInput && this.state.hashTagInput.length > 0? 'normal': 'italic' }}
                value={this.state.hashTagInput} onChangeText={this.hashTagInputChange} placeholder='Add Hashtag'/>
              <TouchableOpacity style={{ backgroundColor: 'gray', flex : 1.5/10 }} activeOpacity={0.5} onPress={this.addHashtag}>
                <Text style={{ backgroundColor: 'pink', height : editHeight, textAlign : 'center', fontFamily : font, fontSize : 14, fontWeight: 'bold', lineHeight : editHeight }}>Post</Text>
              </TouchableOpacity>
            </View>
          </Animated.View>
        }
      </View>
    )
*/
    //console.log("remainingHeight = " + remainingHeight)
    //console.log("listHeight = " + listHeight)
    //let subtractComplexInputHeight = editablePost ? 100 : 0
    //console.log("subtractComplexInputHeight = " + subtractComplexInputHeight)
    //console.log("this.state.tags = " + JSON.stringify(this.state.tags))
    return (
      <View style={{ backgroundColor: 'white', width: componentWidth, height: (remainingHeight)}}>
        <RecyclerListView style={{ backgroundColor: 'white', width : componentWidth, height : (listHeight)}} disableRecycling={true}
          ref={scrollView => this.hashTagScrollView = scrollView}
          layoutProvider={this.hashesLayout} dataProvider={this.state.tags} renderAheadOffset={50}
          rowRenderer={ (type, data) => <HashtagComponent data={data} post={this.state.Post} api={this.api} editable={editablePost}
            auth={this.props.auth} navigation={this.props.navigation} delete={this.deleteHashtag} /> }/>
        {editablePost && this.complexInput('hashtag')}
      </View>
    )
/*
<KeyboardAccessoryNavigation avoidKeyboard='true'/>
View height : editContainerHeight

<Animated.View style={{ backgroundColor: 'green', maxWidth : w, height : editHeight, flexDirection : 'row'
              , justifyContent : 'center', alignItems : 'center', borderWidth : 1, borderColor : 'black', borderRadius : 5
              , minWidth : (w - 10*2), margin : 10, padding : 10
              , position : 'absolute', bottom : this.keyboardHeight, marginTop: 11, marginBottom: 31, backgroundColor : 'white', zIndex : 5000 }}>

<Animated.View style={{ position : 'absolute', bottom : -26, width : w-this.sizes.offset*2-w*0.025-10, height : this.whiteLine, backgroundColor : 'white' }}>
</Animated.View>
*/
  }

  _onPressMention = (userId) => {
    if (this.props.navigation && userId) {
      const { navigate } = this.props.navigation
      if (userId != this.props.auth.user.UserId) {
        navigate('postDetail', { userId: userId })
      } else {
        navigate('profile', { userId: userId })
      }
    }
  }
  
  bBToLink = (code, item, j) => {
    var found = code.match(/\[link ([a-zA-Z]+) (\w{14}|\w{32}) ([-_a-zA-Z]+) (.*)\]/);
    if (found) {
      return (<Text key={generateKey(j)} style={{ fontFamily : font, fontSize : 14, fontWeight : 'bold', color : 'black' }} onPress={() => this._onPressMention(found[2])}>{found[4]}</Text>);
    }
    return false;
  }

  convertMessage = (item) => {
    if (!item || !item.Body) return [] // crashlytics

    // first strip off our encoded reply stuff which is at beginning;
    // however, we may want to leave some of it on later like the 'reply to @name'
    let itemBodyNoReply = this.replaceEncodedReplyString(item.Body)

    itemBodyNoReply = itemBodyNoReply.replace('__DOCNAME__', '') // in case of an attachment, this is the delimiter between url and file name, we dont need to show it

    if (this.isAudioComment(item.Body)) // dont allow audio + other stuff yet
      itemBodyNoReply = ''

    var parts = /*item.Body*/itemBodyNoReply.split(/(\[[^]*?\])/);
    for (var i = 0; i < parts.length; ++i) {
      var href = this.bBToLink(parts[i], item, i);
      if (href) {
        parts[i] = href
      } else {
        if (Platform.OS != 'web') // just leave it alone for web for now
          parts[i] = (<Autolink key={i} style={{ fontFamily : font, fontSize : 14 }} text= {parts[i]} 
          onPress={(link, match) => {
                      const type = match.getType() // email, hashtag, phone, twitter, or url
                      console.log("link = " + link)
                      if (type === 'url' && Platform.OS != 'web') SafariView.openUrl(link) // internal to app web view
                      else Linking.openURL(link)
                    }
                  }/>);

         else
           parts[i] = (<Text key={i} style={{ fontFamily : font, fontSize : 14 }}>{parts[i]}</Text>)
      }
    }
    return parts
  }

  sortCommentsByReply(comments) {
     
    log("-------------------------")

    log("n comments = " + comments.length)

    if (comments.length == 0) return comments

    log("list of ordinary non reply comments:")

    let ordinaryComments = comments.filter((x) => {
       let y = !this.isEncodedReply(x.Body)
       if (y) log("ordinary = " + x.Body)
       return y
    })

    log("n ordinary comments = " + ordinaryComments.length)

    let replyComments = comments.filter((x) => {
     return this.isEncodedReply(x.Body)
    })

    // sort replies so most recent is on bottom
    replyComments = replyComments.sort((a, b) => {
      return a.TimeStamp - b.TimeStamp
    })

    log("n reply comments = " + replyComments.length)

    // to do: this could become n^2 loop for long comment list

    let newComments = ordinaryComments // JSON.parse(JSON.stringify(ordinaryComments)) // better deep copy (broken of course)
    
    commentsToLoopOver = newComments

    commentsToLoopOver.push(newComments[newComments.length-1]) // add 1 more dummy item for insert at end to work, delete it later

    log("commentsToLoopOver with 1 extra at end " + JSON.stringify(commentsToLoopOver, null, 2))

    // if it is a reply to a reply, we need to start w/ full list

    // ref:  https://stackoverflow.com/questions/586182/how-to-insert-an-item-into-an-array-at-a-specific-index-javascript
    Array.prototype.insert = function (index, items) {this.splice.apply(this, [index, 0].concat(items))} 

    log("looping over ordinary comments to start")

      do {
      let startingReplyCount = replyComments.length
      for (let ordinary of commentsToLoopOver) {

        log("start of main loop")
        if (!ordinary) continue // for some reason we get an array with 1 null item at beginning rather than array of 0 length
                                // have to bail out in that case or crash

        // then find all replies that match its time stamp and add them

        // note:  if owner had deleted orig comment, the replies wont match, we will
        // have extra replies 

        let matchingReplies = replyComments.filter((reply) => {
          let replyTime = parseFloat(this.encodedReplyTime(reply.Body))
          log("replyTime = " + replyTime + " checking versus ordinary.TimeStamp = " + ordinary.TimeStamp)
          log ("diff = " + (ordinary.TimeStamp - replyTime))
          if (replyTime > 0 && Math.abs(ordinary.TimeStamp - replyTime) < 0.01) { 
            log("found it!")
            return true  // we have a time match of reply to orig
          }
          else 
            return false
        })

        log("for comment ordinary.Body = " + ordinary.Body)
        log("    n matching replies = " + matchingReplies.length)
        log("    the matching replies are: " + JSON.stringify(matchingReplies, null, 2))

        let indexToInsert = newComments.findIndex(i => Math.abs(parseFloat(i.TimeStamp) - parseFloat(ordinary.TimeStamp)) < 0.01)

        log("indexToInsert = " + indexToInsert)

        if (indexToInsert >= 0 && matchingReplies.length > 0)  {

          newComments.insert(indexToInsert + 1, matchingReplies) // insert after the found element

          log("after adding replies:")
          log(JSON.stringify(newComments, null, 2))

        }

        if (indexToInsert < 0 && matchingReplies.length > 0) {
          log("**** caution, cannot figure out where to insert replies!")
        }

        // remove matchingReplies from replyComments array
        // via https://stackoverflow.com/questions/19957348/remove-all-elements-contained-in-another-array
        
        const toRemove = new Set(matchingReplies)
        log("toRemove n = " + toRemove.size)
        const difference = replyComments.filter( x => !toRemove.has(x) ) // apparently works w/ objects in this case

        log("difference n = " + difference.length)

        replyComments = difference

      } // loop over all ordinary

      log("bottom of looping over remaining " + replyComments.length + " reply comments")

      // we used no replies, get out or we will be in an infinite loop
      // this could be the case if we deleted the orig comment related to a reply
      if (replyComments.length == startingReplyCount) break 

    } while (replyComments.length > 0)

    if (replyComments.length != 0) {

      //Alert.alert('Caution', 'Unable to sort ' + replyComments.length + ' replies', [{ text: "OK" }])

      log('remaining reply comments may be replies to deleted comments')
      log(JSON.stringify(replyComments, null, 2))

    }
    newComments.pop()
    return newComments // now with the replies in the proper order but get rid of fake last element
 }

  // send in username and time stamp of post we are replying to
  computeReplyString = (username, timeStamp) => {
    const replyPrefix = "reply to @" + username + " from " + timeStamp + ":"
    return replyPrefix
  }

  // example 'reply to [link profile P95758977b04c9140001ac1f18a31409 none @user] from 1628274846.21439:'

  // server encodes @username like above so when we get the comments back from server they look like this
  // could maybe try escaped [ and ] instead of dot 
  isEncodedReply = (string) => {
    let r = new RegExp(ENCODED_REPLY_PATTERN) 
    if (string.match(r)) return true
    else return false
  }

  isAudioComment = (string) => {
    let r = new RegExp(AUDIO_PATTERN) 
    if (string.match(r)) return true
    else return false
  }

  audioURL = (string) => {
    let r = new RegExp(AUDIO_GET_URL_PATTERN) 
    let s = string.replace(r, '')
    s = s.replace(/ duration .*/, '')
    return s
  }

  audioDuration = (string) => {
    let r = new RegExp(AUDIO_GET_DURATION_PATTERN) 
    return string.replace(r, '')
  }

  replaceAudioString = (string) => {
    let r = new RegExp(AUDIO_PATTERN_TO_END)
    return string.replace(r, '') 
  }

  // assumes encoded reply comment .Body passed in
  encodedReplyTime = (string) => {
    let r = new RegExp(ENCODED_REPLY_PATTERN_BEFORE_TIME)  
    let r2 = new RegExp(':.*$') 

    let removeLeft = string.replace(r, '')
    let removeRight = removeLeft.replace(r2, '')
    removeRight = removeRight.replace(':','') // lone colon not matching above pattern if first char of reply is \n fix like this for now

    return removeRight

  }

  // determine if this looks like a reply string
  isPlainReply = (string) => {
    let r = new RegExp('^reply to @.+ from [0-9\\.]+:') 
    if (string.match(r)) return true
    else return false
  }

  // if it exists, replace the reply substring string w/ nothing
  replaceEncodedReplyString = (string) => {
    let r = new RegExp(ENCODED_REPLY_PATTERN)
    return string.replace(r, '') 
  }

  // vis-a-vis:  https://stackoverflow.com/questions/3733227/javascript-seconds-to-minutes-and-seconds

  secondsToMinSec = (time) => { // pass in number in seconds, floating pt ok
    let minutes = Math.floor(time / 60)
    let seconds = Math.round(time - minutes * 60)
    const zeroPad = (num, places) => String(num).padStart(places, '0')
    durationText = zeroPad(minutes, 2) + ':' + zeroPad(seconds, 2)
    return durationText
  }  

  // render one row of comments flat list
  Comment = (data, index) => {
    //console.log('rendering comment ' + index /* + " data = " + JSON.stringify(data)*/)
    // console.tron.display({ name: `PostView`, preview: `Comment`, value: { index: index, data: data } })

    const isWeb = (Platform.OS == 'web')

    if (data == null)
      return null
    const isReply = this.isEncodedReply(data.Body)
    const isAudio = this.isAudioComment(data.Body)

    // only valid if isAudio is true
    const theAudioURL = this.audioURL(data.Body)
    const theAudioDuration = this.audioDuration(data.Body)

    // note:  this isnt working yet (change color of origin of reply), not sure if render or logic problem
    // seems like maybe render, check how this flag isOriginOfReply is used in render
    let isOriginOfReply = false
    if (this.state.replyToComment && data.TimeStamp == this.state.replyToComment.TimeStamp)
      isOriginOfReply = true // so we can format it slightly differently so you remember what you are replying to?

    if (isOriginOfReply) console.log("isOriginOfReply index = " + index)

    const replyIndent = null // dont need, do by indenting avatar:  isReply ? (<Text>     </Text>) : null // for testing
    const isCaption = typeof data.IsCaption != 'undefined'
    let canDelete = !isCaption && (this.editablePost || this.props.auth.user.UserId === data.UserId)
    canDelete = (data.PostId === 'anyPost') ? false : canDelete // if this is a temp comment, don't put up the X since we don't know the comment timestamp to delete
    const firstColumn = canDelete ? (
      <TouchableOpacity hitSlop={{left: 15, right: 15, top: 15, bottom: 15}} style={{ flex : 1/10, alignSelf: 'flex-start' }} activeOpacity={0.5} onPress={( ) => this.deleteVerify(data.TimeStamp)}>
        <Image
          style={{ width: 9, height: 9, marginTop: 10, marginLeft: 5, marginRight: 7 }}
          resizeMode="cover"
          source={Images.deleteBtn} />
      </TouchableOpacity>
    ) : !isCaption ?
      (
        <View style={{flex: 1/10, width: 21}}></View>
      ) :
      null
    // don't allow replies to replies yet?  or?
    // use an indexed key to avoid bugs
    // note:  reply to reply shows touch hilite but nothing happens, huh
    // see notes on zIndex
    // https://stackoverflow.com/questions/53548361/react-native-touchableopacity-onpress-not-working-on-android
    // for now, dont show reply button if this is already a reply, there is some bug where the button
    // hilites but the onPress doesnt get triggereds

    let tentativePost = data.PostId === 'anyPost' // post is being uploaded if this is true, so no reply button yet

    const replyButton = !tentativePost ? ( 
      <TouchableOpacity key={"replyButton" + index} style={{position: 'absolute', width : 60, height: 30, bottom : -30 - (isWeb?0:0), left: (isReply?70:50), zIndex: 1}}
        onPress={() => {
          console.log('onPress ready to compute reply string for data = ' + JSON.stringify(data, null, 2))
          const rp = this.computeReplyString(data.Username, data.TimeStamp)
          console.log('computed replyPrefix ' + rp)
          
          if (this.captionRef && this.captionRef.textInput)
            this.captionRef.textInput.focus() // show the keybd for the search bar component aka typing area
          else {
            console.log("cant pop keybd, this.captionRef = " + this.captionRef)
            if (this.captionRef) 
              console.log("cant pop keybd, this.captionRef.textInput = " + this.captionRef.textInput)
            else
              console.log("cant pop keybd no caption ref")
          }
          // store reply to comment so we can hilite it or do something visual 
          this.setState({replyingNow: true, replyPrefix : rp, replyToComment: data}) // clear after a successful post of this reply
        }}>
        <Text key={"replyButtonText" + index} style={{left: 0, color: isReply ? 'green' : 'blue'}}>reply</Text>
      </TouchableOpacity>
    ) : null 
    // https://stackoverflow.com/questions/46680890/react-native-how-to-scroll-a-scrollview-to-a-given-location-after-navigation-f
    // need per comment
     
    let isSmallWidth = (componentWidth == 320) // small phone

    let vwidth = 23 + (true ? 23 : 0)

    // when in play mode icon jumps up, so push it to where it belongs maybe due to crazy rendering of emjoi play/stop button
    // cant use transform due to some clash with animation module ok...thanks react...
    let correctionTransform =  this.state.isPlaying ? 
      {} : {}

    let voiceIcon = isAudio ? (
    <TouchableOpacity onPress={this.playAudio.bind(this, theAudioURL)} style={[{bottom: 20, width: vwidth, height: 20*this.state.voiceLevel}, correctionTransform ]}>
      <Image style={{position: 'absolute', top: 0, width:23, height:17, left:0}} source={Images.audioWave1} />
      {true && <Image style={{position: 'absolute', top: 0, width:23, height:17, left:23+1}} source={Images.audioWave1} />}
      {false && <Image style={{position: 'absolute', top: 0, width:23, height:17, left:23*2}} source={Images.audioWave1} />}
    </TouchableOpacity>
    ) : null

    
    let playText = (this.state.audioUrlPlaying == theAudioURL) ? " ◼︎" : " ▶︎ " + ((theAudioDuration > 0) ? (this.secondsToMinSec(theAudioDuration)) : '')

    if (Platform.OS == 'web') { // no audio on web yet
      playText = null 
      voiceIcon = null
    }

    // not yet
    //if (!this.state.audioFinishedLoading && playText == "Stop ◼︎")
    //   playText = "..."

    // the comment rows were getting centered and of unequal length on first port to web
    // so try to make them equal by using a fixed number for width
    const widthToUse = isWeb ? componentWidth * (this.props.standaloneScreen ? 0.35 : 0.85) : '100%'

    const bbw =  isWeb ? 1 : 0
    
    const origBgColor = (isOriginOfReply ? 'rgab(0,127,0,0.3)': 'rgab(0,127,0,0.0)')

    return (
      <View key={"commentRow" + index} 
        style={{ bottomBorderWith : bbw, borderColor: 'blue', width: widthToUse, flexDirection : 'row', alignItems : 'center', justifyContent : 'flex-start', marginBottom : 30, backgroundColor : origBgColor }}
        onLayout={event => { this.rowOffset[index] = event.nativeEvent.layout.y }}>
        {firstColumn}
        <View style={{ marginLeft: (isReply ? 20 : 0), flex: 1/8, paddingRight: 10, alignSelf: 'flex-start' }}>
          <AvatarComponent style={{marginTop: 0, borderWidth: 0}} size={30} userId={data.UserId} onPress={() => this._onPressMention(data.UserId)}/>
        </View>
        <Text style={{ flex : 1, flexDirection : 'row', alignSelf: 'flex-start', alignItems : 'flex-start', flexWrap : 'wrap' }}>
            {replyIndent}
            <Text onPress={( ) => this._onPressMention(data.UserId)} style={{ fontFamily : boldFont, fontSize : 14 }}>{data.Username} </Text>
            <Text style={[{ left: 20, fontFamily : font, fontSize : 14}, isReply ? {color : 'green'} : {} ]}>{this.convertMessage(data)}</Text>
            {voiceIcon}
            {isAudio && <Text style={{left: 20, height:20}} onPress={ () => {
                console.log("ready to play audio " + theAudioURL)
                this.playAudio.call(this, theAudioURL)
            }
            }>{playText}</Text>}
        </Text>
        <Text style={{ flex : 1.5/10, paddingTop: 0, alignSelf: 'flex-start', textAlign : 'right', width : widthToUse, fontFamily : font, fontSize : 14 }}>
          {convertTime(data.TimeStamp)}
        </Text>
        {replyButton}
      </View>
    )
  }
  
  captionView(post) {
    const haveCaption = this.state.Post.Caption && this.state.Post.Caption.length > 0
    return !haveCaption ? null :
      this.Comment({
        IsCaption: true,
        UserId: post.UserId,
        Username: post.Username,
        TimeStamp: post.TimeStamp,
        Body: post.Caption,
      })
  }
    
  createCommentFromCaption(post) {
    const haveCaption = this.state.Post.Caption && this.state.Post.Caption.length > 0
    return !haveCaption ? null :
      {
        IsCaption: true,
        UserId: post.UserId,
        Username: post.Username,
        TimeStamp: post.TimeStamp,
        Body: post.Caption,
      }
  }
  
  // pass in doc browser result directly
  postPDFAsComment(docResult) {

    //this.setState({fileCopyUri: x.fileCopyUri, fileCopyUriName: x.name, fileCopyUriMimeType: x.type}) 

    if (this.state.PDFIsPosting) return // avoid double tap situations

    this.setState({PDFIsPosting: true})
    let mediaId = 0 // maybe this needs to be low N (could go bad if we delete then make another, hmm)
    let ts = Date.now()
    // ts = ts.replace('.', '')
    console.log("this.props.Post = " + JSON.stringify(this.props.Post))
    console.log("this.props.Post.PostId = " + this.props.Post.PostId)
    let itemId = "PDF" + this.props.Post.PostId + "_TS_" + Date.now()

    // to do
    let fileSourcePath = docResult.fileCopyUri.replace('file://', '') 
    fileSourcePath = decodeURI(fileSourcePath) // plain path no fancy % stuff
    console.log("PDF fileSourcePath = " + fileSourcePath)
    RNFS.stat(fileSourcePath).then((x) => {
      console.log("stat fileSourcePath = " + JSON.stringify(x))
    }).catch((x) => {
      console.log("cannot stat file x = " + JSON.stringify(x))
    })

    this.api.createMyShopUrl(itemId, 'pdf', mediaId)
        .then(resp => {
          console.log("got pdf url upload path resp " + JSON.stringify(resp, null, 2))
          let { myShop } = resp.data.meta // myShop key is in response, could change it locally because this is not a myShop
          const headers = { 'Content-Type' : 'application/pdf' }
          console.log("ready to upload PDF from result.path = " + fileSourcePath)

          this.setState({loading: true}) // uploading

          RNFetchBlob.fetch('PUT', myShop._url, headers, RNFetchBlob.wrap(fileSourcePath)) // to do
              .then( () => {
                console.log("pdf upload ok for comments, uploaded url = " + myShop.url)
                //this.mediaUrls[this.mediaUrls.length - 1] = meta.url
                this.state.commentInput = 'PDF Attachment ' + myShop.url + ' __DOCNAME__ ' + docResult.name
                this.addComment()

                this.setState({loading: false}) // uploading
              })
              .catch((x) => {
                console.log("CATCH error uploading PDF for comments x = " + JSON.stringify(x))
                Alert.alert(`Upload PDF error`, 'Check internet connection, please try again', [{ text: "OK" }])
                this.setState({PDFIsPosting: false})
              })
	      }).catch((x) => {
          console.log("cannot get PDF url " + JSON.stringify(x))
          Alert.alert(`Upload PDF error`, 'Check internet connection, please try again', [{ text: "OK" }])
          this.setState({PDFIsPosting: false})
        })

  }

  // posts the commonly named file stored by record audio

  postAudioAsComment() {

    if (this.state.audioIsPosting) return // avoid double tap situations

    this.setState({audioIsPosting: true})
    let mediaId = 0
    let ts = Date.now()
    // ts = ts.replace('.', '')
    console.log("this.props.Post = " + JSON.stringify(this.props.Post))
    console.log("this.props.Post.PostId = " + this.props.Post.PostId)
    let itemId = "AUDIO" + this.props.Post.PostId + "TIME" + ts // no decimals no need for fraction of millisec, or?

    let audioFileSourcePath = this.state.newAudioFilePath // direct from result.path from sound recorder

    this.api.createMyShopUrl(itemId, 'mp4', mediaId)
        .then(resp => {
          console.log("got audio url upload path resp " + JSON.stringify(resp, null, 2))
          let { myShop } = resp.data.meta // myShop key is in response, could change it locally because this is not a myShop
          const headers = { 'Content-Type' : 'application/octet-stream' }
          console.log("ready to upload audio from result.path = " + audioFileSourcePath)
          RNFetchBlob.fetch('PUT', myShop._url, headers, RNFetchBlob.wrap(audioFileSourcePath))
              .then( () => {
                console.log("audio upload ok for comments, uploaded url = " + myShop.url)
                //this.mediaUrls[this.mediaUrls.length - 1] = meta.url
                this.state.commentInput = 'audioComment ' + myShop.url + " duration " + this.state.audioDurationSeconds.toFixed(1)
                this.addComment()
                // this.setState({audioIsPosting: false}) // move this to successful upload of the comment
              })
              .catch((x) => {
                console.log("CATCH error uploading audio for comments x = " + JSON.stringify(x))
                Alert.alert(`Upload voice note error`, 'Check internet connection, please try again', [{ text: "OK" }])
                this.setState({audioIsPosting: false})
              })
	      }).catch((x) => {
          console.log("cannot get audio url " + JSON.stringify(x))
          Alert.alert(`Upload voice note error`, 'Check internet connection, please try again', [{ text: "OK" }])
          this.setState({audioIsPosting: false})
        })
  }

  externalRecordAudio() {
    this.recordAudio.call(this)
  }

  // may need auto filter
  selectPDF() {

    DocumentPicker.pick({type: 'com.adobe.pdf'}).then((x) => {
        console.log("got doc " + JSON.stringify(x))
        // this is file://  name is plain text ... MIME type like application/pdf (not fancy mime from apple)
        this.postPDFAsComment(x) 
        //this.setState({fileCopyUri: x.fileCopyUri, fileCopyUriName: x.name, fileCopyUriMimeType: x.type}) 
    })

  }

  // start / stop toggle
  recordAudio() {

    this.stopPlayingAudio() // if we are starting or stopping the audio, make sure playing is stopped when we touch that record button

    if (this.state.isRecording) {
      console.log("record audio loc 1 STOP")
      if (this.recordingInterval)
        clearInterval(this.recordingInterval)
      this.recordingInterval = null
      this.setState({isRecording: false})
      if (Platform.OS != 'web')
      SoundRecorder.stop()
	    .then(function(result) {
		    console.log('stopped recording, audio file saved at: ' + result.path)
        console.log('this keys = ' + Object.keys(this))
        // this saves absolute path not file:// as-is from recorder
        this.setState({hasRecorded : true, newAudioFilePath: result.path}) // so we know an audio file is avail

        // now load it in the player so the user can see the duration
        if (Platform.OS != 'web')
        SoundPlayer.loadUrl("file://" + result.path)

        console.log("after setState, this.props = " + this.props)
        let mediaId = 0
        let ts = Date.now()
        // ts = ts.replace('.', '')
        console.log("this.props.Post = " + JSON.stringify(this.props.Post))
        console.log("this.props.Post.PostId = " + this.props.Post.PostId)
        let itemId = "AUDIO" + this.props.Post.PostId + "TIME" + ts // no decimals no need for fraction of millisec, or?

        console.log("itemId = " + itemId)

      }.bind(this))
    }
    else {
      console.log('start recording audio')
      this.setState({isRecording: true})
      this.setState({recordingTimeStart: Date.now()})
      if (Platform.OS != 'web')
      SoundRecorder.start(SoundRecorder.PATH_CACHE + '/commentAudio.mp4')
	    .then(() => {
        
        this.recordingInterval = setInterval(() => {
          console.log("recording " + Date.now())
          this.setState({recordingTimeMillisec: Date.now()})
        }, 100)
		    console.log('after started recording')
	    }) 
      .catch((x) => {
        Alert.alert(`Audio recording error`, 'Check if some other app such as telephone is using the microphone.', [{ text: "OK" }])
      })
    }

  }

  stopPlayingAudio() {

     // have to force redraw to flip the play button if this is in the list
    this.setState({isPlaying: false, audioUrlPlaying : null, forceRedrawComments: true})
    if (Platform.OS != 'web')
    SoundPlayer.stop()

  }
  // if no url, use default
  playAudio(url) {

    if (this.state.isPlaying) {
     
      this.stopPlayingAudio()

	    //.then(function(result) {
		  //  console.log('stopped recording, audio file saved at: ' + result.path);
	    //});
    }
    else {
      if (Platform.OS == 'web') return
      // have to force redraw to flip the play button
      console.log("url input = " + url)
      let urlToPlay = (url && typeof url == 'string') ? url : "file://" + SoundRecorder.PATH_CACHE + '/commentAudio.mp4'
      console.log("urlToPlay = " + urlToPlay)
      this.setState({isPlaying: true, audioUrlPlaying : urlToPlay, forceRedrawComments: true})
      this.setState({audioFinishedLoading: false}) // this should go to true when audio is ready
      SoundPlayer.playUrl(urlToPlay)
	    //.then(function() {
		  //  console.log('started playing');
	    //});
    }

  }

  // maybe use this separately outside this component, not sure yet
  // not used here
  audioPreviewButtonBlock() {
      let playText = this.state.isPlaying ? "Stop ◼︎" : "Play ▶︎"
      let audioDurText = this.state.audioDurationSeconds > 0 ? (this.state.audioDurationSeconds.toFixed(1) + ' sec') : ''
      let postAudioText =  (!this.state.audioIsPosting && this.state.audioDurationSeconds > 0 ) ? 'PostAudio' : ''
      let postAudioX = componentWidth == 320 ? 190 : 260 // move to left for small screen
      return (
        <View>
          {!this.state.isRecording && <Text style={{position: 'absolute', height: 30, bottom: 20, left: 120}} onPress={this.playAudio.bind(this)}>{playText}</Text>}
          {!this.state.isRecording && <Text style={{position: 'absolute', height: 30, bottom: 20, left: 190}}>{audioDurText}</Text>}
          {!this.state.isRecording && <Text style={{position: 'absolute', height: 30, bottom: 60, left: postAudioX}} onPress={this.postAudioAsComment.bind(this)}>{postAudioText}</Text>}
        </View>
      )
  }
  // optional transform arg to move it up to where you are replying so you know you are replying
  // idea only, not implemented yet

  complexInput(kind, transform) {
    const shouldDisplay = true
/*
    const containerStyle = {
      height: 70,
      width: w,
      bottom: 0,
      backgroundColor: 'white',
      display : (shouldDisplay? 'flex': 'none')
    }
    const textInputStyle = {
      margin: 5,
      paddingBottom: 30,
      paddingRight: 90,
      flex: 1,
      fontFamily : Fonts.style.font.regular,
      backgroundColor: 'orange'
    }
*/
    // following={this.props.following}
    // onBlur={this.inputCapnofocus}
    // onfocus={this.inputCapforcus}
    // margin: 5,
    const minHeight = 55
    const bottomPadding = 4 // 16
    const wrapperStyle = {
      width: componentWidth,
      minHeight: minHeight + 10 + bottomPadding, //  70,
      zIndex: 50,
      position: 'absolute',
      paddingBottom: bottomPadding,
      bottom: this.keyboardHeight, // 22  10  0  this.keyboardHeight
      backgroundColor: this.props.isPopup ? 'rgba(0,0,0,0)' : 'white', // 'rgba(250,250,250,0.5)',
      display : (shouldDisplay? 'flex': 'none'),
    }
    const containerStyle = {
      marginTop: 5,
      marginBottom: 5,
      marginLeft: 20,
      marginRight: 20,
      height: minHeight, // 70,
      width: componentWidth - 40,
      backgroundColor: 'white',
      display : (shouldDisplay? 'flex': 'none'),
      borderWidth: 1,
      borderRadius: 10,
      borderColor: 'black',
      // bottom: 10, // 0
    }
      
    const isWeb = Platform.OS == 'web'

    const textInputStyle = {
      color: 'black',
      padding: isWeb ? 8 : 0, // web
      margin: 0,
      paddingBottom: 8, // 30,
      marginRight: 50 + 20, // add 20 to margin for portuguese 1.2 font scale
      marginTop: 8,
      flex: 1,
      fontFamily : Fonts.style.font.regular,
      backgroundColor: 'white',
      borderWidth: 0,
      borderRadius: 10,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    }
    // https://github.com/Flipkart/recyclerlistview   renderFooter
    const following = typeof this.props.following != 'undefined' ? this.props.following : []
    //console.log("should clear typing in post view component = " + this.state.shouldClearTyping)
    if (kind == 'comment') {
      //console.log('ready to render search bar component, this.state.commentInput = ' + this.state.commentInput + ' shouldClearTyping = ' + this.state.shouldClearTyping + ' commentBeingSent ' + this.state.commentBeingSent)
      // note:  initialValue doesnt seem to work if you haven typed
      
      let replyToUsername = ''
      let replyMsg = 'add your reply here' // unknown username shouldnt happen
      if (this.state.replyToComment) {
        replyToUsername = this.state.replyToComment.Username
        replyMsg = 'reply to @' + replyToUsername
      }

      const placeholder = this.state.replyingNow ? replyMsg : I18n.t('postDetail.addComment')

      let recText = this.state.isRecording ? "Stop ◼︎" : "Record ●"
      let playText = this.state.isPlaying ? "Stop ◼︎" : "Play ▶︎"
      let audioDurText = this.state.audioDurationSeconds > 0 ? (this.state.audioDurationSeconds.toFixed(1) + ' sec') : ''
      let postAudioText =  (!this.state.audioIsPosting && this.state.audioDurationSeconds > 0 ) ? 'PostAudio' : ''
      let postAudioX = componentWidth == 320 ? 190 : 260 // move to left for small screen

      return (
        <Animated.View style={wrapperStyle}>
          <SearchBarComponent
            standaloneScreen={this.props.standaloneScreen}
            minHeight={minHeight}
            ref={ ref => this.captionRef = ref ? ref : this.captionRef /* only set ref if non zero */}
            autoCorrect={true}
            spellCheck={true}
            initialValue={this.state.commentInput}
            atTaggable={true}
            textWrapperStyle={{}} // backgroundColor: 'blue', borderWidth: 0
            textInputStyle={textInputStyle} // note: font is not set here
            onChangeText={this.commentInputChange}
            onPost={this.addComment}
            blurOnSubmit={false}
            api={this.api}
            following={following}
            multiline={true}
            numberOfLines={5}
            hiddenClear
            autoGrow={true}
            placeholder={placeholder /*I18n.t('postDetail.addComment')*/}
            style={containerStyle}
            isBusy={this.state.commentBeingSent} 
            shouldClearTyping={this.state.shouldClearTyping} 
            atTagPopupLeft={-10}
            onLayoutAndMeasure={(layout, measure) => {
              // layout may not be right but we dont need it, measure is to full screen
              console.log("complex input measure = " + JSON.stringify(measure))

              this.bottomOfDataEntry = measure.pageY + measure.height

              console.log("purported bottom of data entry = " + JSON.stringify(this.bottomOfDataEntry))
            }}
            />
          {!isWeb && <Text style={{position: 'absolute', height: 30, top: 20, right: 30, color: 'rgba(0,0,0,0.5)', backgroundColor: 'white'}} onPress={this.selectPDF.bind(this)}>PDF 📄</Text>}
          {(!isWeb && !this.props.isPopup) && <Text style={{position: 'absolute', height: 30, bottom: 20, left: 40, color: 'red'}} onPress={this.recordAudio.bind(this)}>{recText}</Text>}
          {(!isWeb && !this.props.isPopup) && !this.state.isRecording && <Text style={{position: 'absolute', height: 30, bottom: 20, left: 120}} onPress={this.playAudio.bind(this)}>{playText}</Text>}
          {!this.props.isPopup && !this.state.isRecording && <Text style={{position: 'absolute', height: 30, bottom: 20, left: 190}}>{audioDurText}</Text>}
          {!this.props.isPopup && !this.state.isRecording && <Text style={{position: 'absolute', height: 30, bottom: 60, left: postAudioX}} onPress={this.postAudioAsComment.bind(this)}>{postAudioText}</Text>}

        </Animated.View>
      )
    }
    else if (kind == 'hashtag')
      return (
        <Animated.View style={wrapperStyle}>
          <SearchBarComponent
            minHeight={minHeight}
            ref={ ref => this.hashRef = ref }
            autoCorrect={true}
            spellCheck={true}
            initialValue={``}
            atTaggable={true}
            textWrapperStyle={{}} // backgroundColor: 'blue', borderWidth: 0
            textInputStyle={textInputStyle} // note: font is not set here
            onChangeText={this.hashTagInputChange}
            onPost={this.addHashtag}
            blurOnSubmit={false}
            api={this.api}
            following={[]}
            multiline={false}
            numberOfLines={1}
            hiddenClear
            autoGrow={false}
            placeholder={I18n.t('postDetail.addhashtag')}
            style={containerStyle} />
        </Animated.View>
      )
/*
      <TextInput style={{ backgroundColor: 'yellow', flex : 8.5/10, color : 'black', height : editHeight, fontFamily : font,
       fontSize : 14, fontStyle : this.state.hashTagInput && this.state.hashTagInput.length > 0? 'normal': 'italic' }}
        value={this.state.hashTagInput} onChangeText={this.hashTagInputChange} placeholder='Add Hashtag'/>
*/    
  }
  
  simpleInput() {
    let remainingHeight = h - this.sizes.offset - this.sizes.title - this.sizes.tab
      , editablePost = this.state.Post.UserId === this.props.auth.user.UserId
      , recyclerHeight = remainingHeight - this.sizes.captionMinHeight - remainingHeight*0.1
      , showUsers = this.activeTag? true: false
      , post = this.state.Post
      , haveCaption = this.state.Post.Caption && this.state.Post.Caption.length > 0
    return (
      <Animated.View style={{ width : componentWidth - 2 * 10, height : remainingHeight * 0.075, flexDirection : 'row'
                    , justifyContent : 'center', alignItems : 'center', borderWidth : 1, borderColor : 'black', borderRadius : 5
                    , minWidth : (componentWidth - this.sizes.offset*2) * 0.9, margin : 10, padding : 10
                    , position : 'absolute', bottom : this.keyboardHeight, marginBottom: 20, backgroundColor : 'white', zIndex : 50 }}>

        <View style={{ flexDirection : 'column', width : '100%', position : 'absolute'
                    , display : (showUsers ? 'flex' : 'none'), alignItems : 'center', justifyContent : 'flex-end'
                    , top : -270, left : 0, height : 250, zIndex : 50 }}>
          { this.tagResults ( ) }
        </View>
        <TextInput style={{ flex : 8.5/10, color : 'black', height : remainingHeight * 0.075, fontFamily : font, fontSize : 14, fontStyle : this.state.commentInput && this.state.commentInput.length > 0? 'normal': 'italic' }}
          value={this.state.commentInput} onChangeText={this.commentInputChange} placeholder={I18n.t('postDetail.addComment')}
          onSelectionChange={this.onSelect} spellCheck={true}/>
        <TouchableOpacity style={{ flex : 1.5/10 }} activeOpacity={0.5} onPress={this.addComment}>
          <Text style={{ height : remainingHeight * 0.075, textAlign : 'center', fontFamily : font, fontSize : 14, lineHeight : remainingHeight * 0.075 }}>
            Post
          </Text>
        </TouchableOpacity>
        <Animated.View style={{ position : 'absolute', bottom : -26, width : componentWidth-this.sizes.offset*2-componentWidth*0.025-10, height : this.whiteLine, backgroundColor : 'white' }}>
        </Animated.View>
      </Animated.View>
    )
  }

  CommentsView = ( ) => {
    let remainingHeight = h - this.sizes.offset - this.sizes.title - this.sizes.tab  
      , editablePost = this.state.Post.UserId === this.props.auth.user.UserId
      , editContainerHeight = editablePost ? 66 : 0 // remainingHeight * 0.075
      , listHeight = remainingHeight - editContainerHeight - 20 // 0.9 * remainingHeight
      , showUsers = this.activeTag? true: false
      , post = this.state.Post
      , haveCaption = this.state.Post.Caption && this.state.Post.Caption.length > 0
      , forceRedrawComments = this.state.forceRedrawComments // clear this state after we use this
    if (forceRedrawComments) console.log("***forceRedrawComments")
    // the EfficientFlatList redraws if nItems changes so we just bump it if we want to force redraw (see below)
    // note:  nItems is only used to know whether to redraw or not, it is not the actual list count, so we should be safe
    this.state.forceRedrawComments = false // but dont use setState so we dont draw again
    // this.simpleInput(remainingHeight)
    const isSimple = false
    const heightScale = isSimple ? 0.9 : 0.8
    //console.log("this.state.comments = " + JSON.stringify(this.state.comments))
    const cFromC = this.createCommentFromCaption(post) // comment from caption
    // dont put a null at the front, it messes up flatlist
    // raw order that user sent, most recent at top
    let captionAndComments = cFromC ? [cFromC, ...this.state.comments] : [...this.state.comments]

    // put replies in the proper order (indent if needed will occur in later render of the indiv comment)
    // this may be getting called too often every render
    captionAndComments = this.sortCommentsByReply(captionAndComments)

    // note:  above structure makes [null] if no caption or comments (e.g. array of length 1 but an item null so have to check for that
    let nCaptionAndComments = captionAndComments.length
    //console.log("captionAndComments = " + JSON.stringify(captionAndComments))
    //console.log("nCaptionAndComments = " + JSON.stringify(nCaptionAndComments))
    const firstItem = nCaptionAndComments > 0 ? captionAndComments[0] : false
    //console.log("firstItem = " + JSON.stringify(firstItem))
    // disableScrollViewPanResponder is for a bug, onTouch not fired immediately after render,
    // meaning, it fails every other time at least
    // https://github.com/facebook/react-native/issues/20011
    // supposedly fixed in a later react-native release, see above
    // subtract 170 from flat list height to keep it from being behind the complex input (typing area)
    // which is hard coded to 170 now (aug 8 2021) in recent prior commits

    return (
      <View style={{ backgroundColor: this.props.isPopup ? 'rgba(0,0,0,0)' : 'white', width: componentWidth, height: this.props.isPopup ? 170 : remainingHeight }}>
        { (!!firstItem && !this.props.isPopup) && <EfficientFlatList 
          onScrollToIndexFailed={(x)=>{console.log('scroll to index failed ' + JSON.stringify(x))}} 
          initialNumToRender={this.state.comments.length} keyboardShouldPersistTaps="always" disableScrollViewPanResponder={true} nItems={nCaptionAndComments + (forceRedrawComments?10:0)} ref={scrollView => this.commentScrollView = scrollView}
          style={{width : componentWidth, height:'100%', backgroundColor: 'white'}}
          contentContainerStyle={{ backgroundColor: 'white', flexDirection : 'column', alignItems : (Platform.OS == 'web') ? 'flex-start' : 'center', justifyContent : 'flex-start', margin : 10, marginBottom: 0, paddingBottom: 60 + 170 }}
          data={captionAndComments}
          renderItem={({item, index, separators}) => (
            this.Comment.call(this, item, index)
            // old ScrollView way for ref:  {captionAndComments.map(this.Comment)}
          )}>
        </EfficientFlatList> }
        {this.complexInput.call(this,'comment')}
        {this.state.loading && <ActivityIndicator color="#0000ff" style={{position: 'absolute', width: '100%', bottom: '13%', zIndex: 100}} size="large" />}
      </View>
    )
    // <KeyboardAccessoryNavigation avoidKeyboard='true'/>
    // <ScrollView contentContainerStyle={{ backgroundColor: 'white', height: listHeight, flexDirection : 'column', alignItems : 'center', justifyContent : 'flex-start', margin : 10, marginBottom: 0 }}>
    // {this.captionView(post)}
    // {this.state.comments.map(this.Comment)}
    // {captionAndComments.map((item, comment) => this.Comment(comment, item)}
  } // CommentsView

  renderTabBar = props => {
    console.tron.log('!!!rendering post view component')
    let numTags = this.hashtags.filter(e => e !== 'NULL').length
      , tabTextStyle = { fontFamily : font, fontSize : 14, textAlign : 'center', lineHeight : this.sizes.tab }
      , tabStyle = { flex : 1/3, borderWidth : 1, borderColor : '#00000070', height : this.sizes.tab }
      , selectedTabStyle = { flex : 1/3, borderWidth : 1, borderColor : '#000000FF', height : this.sizes.tab }
      , boldFont =  { fontFamily: Fonts.style.font.bold }
    let textStyle = { color : 'black', fontSize : 14
                    , height : 25, lineHeight : 25
                    , textAlign : 'center'
                    , fontFamily: Fonts.style.font.regular
                    }
    , tabState = [ textStyle, textStyle, textStyle ]
    
    return (
      <TabBar
        {...props}
        tabStyle={{ height : 30, marginBottom : 15 }}
        labelStyle={tabState[this.state.tab]}
        indicatorContainerStyle={{ backgroundColor: 'white' }}
        indicatorStyle={{ backgroundColor: 'black' }}
        renderLabel={this.renderLabel}
      />
    );
  }
  
  renderTabScene = ({ route }) => {
    switch (route.key) {
      case 'loves':
        return this.LovesView( );
      case 'comments':
        return this.CommentsView.call(this)
      default:
        return this.HashtagView( );
    }
  }
  renderLabel = ({ route }) => {
    let textStyle = { color : 'black', fontSize : 14
                    , height : 25, lineHeight : 25
                    , textAlign : 'center'
                    , fontFamily: Fonts.style.font.regular
                    }

      , underlineStyle = { borderColor : 'black', borderBottomWidth : 1, flex : 0 }
      , tabState = [ [textStyle, this.state.tab === 'Loves' ? boldFont : {}],
                     [textStyle, this.state.tab === 'Comments' ? boldFont : {}],
                     [textStyle, this.state.tab === 'Hashtags' ? boldFont : {}] 
                   ]
      , underline = [ this.state.tab === 0 ? underlineStyle : { }
                    , this.state.tab === 1 ? underlineStyle : { }
                    , this.state.tab === 2 ? underlineStyle : { }
                    ]
      let counter = this.countInterations(route.key);

      return (
        // <View style={underline[this.state.tab]}>
          <Text maxFontSizeMultiplier={1.2} style={tabState[this.state.tab]}>{`${counter} ${route.title}`}</Text>
        // </View>
      );

    }
           
    countInterations = (routeKey) => {
      let numTags = this.hashtags.filter(e => e !== 'NULL').length
      
      switch (routeKey) {
        case 'loves':
          return this.state.Post.NumLikes;
        case 'comments':
          return this.state.Post.NumComments;
        default:
          return numTags;
      }
    }

    render( ) {
      const navigationState = {
        index: this.state.tab,
        routes: this.state.routes
      }
  
    // note:  when adding or deleting comments we don't re-pull the post record, so comment count is not updated
    // we can use this.state.comments length only if total count is < 100 since it only pulls recent 100 comments for display it seems

    // dont compute this unnecessarily, it is used when this component is for comment entry only
    // otherwise complex input is shown on one of the tab views
    // let complexInputOnly = this.props.isPopup ? this.complexInput.call(this,'comment') : null

    if (this.props.isPopup) return this.CommentsView.call(this)
  
    return (

      <View style={{padding: 0, flex: 1}}>

        <TabView
            navigationState={navigationState}
            renderTabBar={this.renderTabBar}
            renderScene={this.renderTabScene.bind(this)}
            onIndexChange={index => this.setState({ tab : index })}
            initialLayout={{ width: componentWidth }}
        />

      </View>
    )
  }
}
